import styled from 'styled-components';

export const ModalSharePostBoxWrap = styled.div`
  position: relative;
  
  .ant-modal-title {
    text-align: left;
  }
`;
